import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import {environment} from '../environments/environment';
import { ThemeService } from '../assets/theme/theme.service';

@Component({
    selector: 'app-my-app',
    templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {
  private _router: Subscription;

  constructor( private router: Router, private themeService: ThemeService ) {
  }

    ngOnInit(): void {
      this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
        const body = document.getElementsByTagName('body')[0];
        const modalBackdrop = document.getElementsByClassName('modal-backdrop')[0];
        if (body.classList.contains('modal-open')) {
          body.classList.remove('modal-open');
          modalBackdrop.remove();
        }
      });
      const url: string = window.location.href;
      this.themeService.setTheme(this.themeService.getForURL(url));
      localStorage.setItem('encodedEnv', btoa(this.themeService.getEnv(url)));
      localStorage.setItem('encodedTenant', btoa(this.themeService.getForURL(url)));
    }
}
